import { render, staticRenderFns } from "./PatientVisitQueriesMenu.vue?vue&type=template&id=6a410eb1&scoped=true"
import script from "./PatientVisitQueriesMenu.vue?vue&type=script&lang=ts"
export * from "./PatientVisitQueriesMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a410eb1",
  null
  
)

export default component.exports